import React from 'react';
import {connect} from 'react-redux';
// Components
import Header from 'Components/common/Header';
import BasicButton from 'Components/common/BasicButton';
import Dialog from 'Components/common/Dialog';
import ReceivePackageCard from 'Components/host/ReceivePackageCard';
import {
    Checkbox,
    Stepper,
    Step,
    StepLabel,
    StepContent,
    Typography,
} from '@material-ui/core';
import SearchInput from 'Components/common/SearchInput';
import LoadingIcon from 'Components/icons/LoadingIcon';

// Actions
import {openNotification} from 'Actions/notification';
import {
    updateF1OrderReceiveSearchList,
    getF1ShipmentWaitReceive,
    getF1ShipmentWaitShipped,
    getF1ShipmentReceived,
    f1ReceivePackage,
    viewOnTheGoPackage,
    viewOrderTracking,
    setF1OrderOnGoPackageSource,
    getF1MessageList,
    clearF1PackageData,
} from 'Actions/host';
import {T} from 'Actions/translate';

class F1OrderOnTheGoPackageReceive extends React.Component {
    state = {
        productsReceivingQuantity: [],
        receiveBtnsIsLoading: [],
        receiveAllBtnIsLoading: false,
        exitOpened: false,
        receiveExitOpened: false,
        f1OrderReceiveData: [],
        isAllReceive: false,
        productQuantity: [],
        currentItem: null,
        currentIndex: 0,
        checked: true,
        defaultCheck: null,
        checkAll: true,
        currentProductIds: [],
        allReceiveOrderArry: [],
        f1OrderReceiveList: [],
        orderNumber: '',
        f1WaitReceivedList: {},
        allF1WaitShippedList: {},
        f1WaitShippedList: {},
        f1ReceivedList: {},
        packageStatus: 'toBeReceived',
        f1PackageReceivePageLoad: true,
        cancelReceivePackageDialogOpened: false,
        receiveQuantity: 0,
        activeStep: 0,
        trackAndTraceLogsArry: [],
        stepsDescriptionArry: [],
        stepsTimeArry: [],
        currentCarrierName: '',
        f1OrderExpandLessMessageFlag: true,
    };

    componentWillMount() {
        this.props.updateF1OrderReceiveSearchList({
            queryKey: {$set: ''},
        });

        this.getPackageReceive();
        this.viewOrderTracking();
    }

    componentWillUnmount() {
        this.props.clearF1PackageData();
    }

    viewOrderTracking = () => {
        let routerState = this.getRouterState();
        let params = {
            shipmentNumber: routerState.shipmentNumber,
            f1Number: routerState.f1Number,
        };
        // let params = {
        //     shipmentNumber: '1215498772',
        //     f1Number: '10943645'
        // }
        // let params = {
        //     shipmentNumber: '1220161561',
        //     f1Number: '13631044'
        // }
        this.props.viewOrderTracking(params).then((res) => {
            if (res && res.status === 'success') {
                if (res.data.length > 0) {
                    let allTrackingLogsArry = [];
                    let tempCarrierName = '';

                    res.data.forEach((currentTracking) => {
                        let tempTrackAndTraceLogs = currentTracking.events;

                        tempCarrierName = currentTracking.carrierName;
                        if (tempTrackAndTraceLogs.length > 0) {
                            allTrackingLogsArry = allTrackingLogsArry.concat(
                                tempTrackAndTraceLogs,
                            );
                        }
                    });

                    let tempStepDescriptionArry = [];
                    let tempStepsTimeArry = [];
                    allTrackingLogsArry.length > 0 &&
                        allTrackingLogsArry.forEach((trackObj) => {
                            tempStepDescriptionArry.push(
                                trackObj.eventDescription,
                            );
                            tempStepsTimeArry.push(trackObj.eventDateTime);
                        });

                    this.setState({
                        trackAndTraceLogsArry: allTrackingLogsArry,
                        stepsDescriptionArry: tempStepDescriptionArry,
                        stepsTimeArry: tempStepsTimeArry,
                        currentCarrierName: tempCarrierName,
                    });
                }
            }
        });
    };

    onChange = (title, value) => {
        this.props.updateF1OrderReceiveSearchList({
            [title]: {$set: value},
        });
    };

    search = () => {
        this.setState({f1OrderReceiveList: []});
        this.getPackageReceive();
    };

    getCurrentWaitShippedData = (queryKey) => {
        let currentWaitReceiveList = JSON.parse(
            JSON.stringify(this.state.allF1WaitShippedList),
        );

        let currentQueryKey = queryKey.trim();
        if (
            currentWaitReceiveList.waitShipSkus &&
            currentWaitReceiveList.waitShipSkus.length > 0
        ) {
            let waitShipSkus = currentWaitReceiveList.waitShipSkus;
            let currentWaitShippedSkuArrys = [];
            waitShipSkus.map((waitShipItem, waitShipIndex) => {
                let currentItem = Object.assign({}, waitShipItem);
                let reg = eval('/' + currentQueryKey + '/ig');
                if (currentItem.sku && reg.test(currentItem.sku)) {
                    currentWaitShippedSkuArrys.push(currentItem);
                }
            });
            currentWaitReceiveList.waitShipSkus = currentWaitShippedSkuArrys;
        }
        this.setState({
            f1WaitShippedList: currentWaitReceiveList,
        });
    };
    getPackageReceive = () => {
        let params = {};
        let routerState = this.getRouterState();
        let orderId = routerState.id;

        let currentSKU = '';
        if (this.props.queryKey) {
            currentSKU = this.props.queryKey;
        } else {
            if (this.props.queryKey.trim()) {
                currentSKU = this.props.queryKey.trim();
            } else {
                currentSKU = '';
            }
        }

        params = {
            orderId: orderId,
            shipmentNumber: routerState.shipmentNumber,
            f1Number: routerState.f1Number,
            sku: currentSKU,
        };

        this.props
            .viewOnTheGoPackage(params)
            .then((res) => {
                if (res && res.status === 'success') {
                    let waitReceiveList = res.data;
                    JSON.stringify(waitReceiveList) !== '{}' &&
                        waitReceiveList.products &&
                        waitReceiveList.products.length > 0 &&
                        res.data.products.map(
                            (packageProductItem, packageProductIndex) => {
                                packageProductItem.checked = true;
                                packageProductItem.expandLessMessageFlag = true;
                            },
                        );
                    this.setState(
                        {
                            f1WaitReceivedList: waitReceiveList,
                            f1PackageReceivePageLoad: false,
                        },
                        () => {
                            this.showOrderNumber(waitReceiveList);
                            // 2. 请求消息列表
                            if (waitReceiveList.eoneNumber) {
                                this.fetchAndMergeMessages(
                                    waitReceiveList.eoneNumber,
                                    waitReceiveList.products || [],
                                );
                            }
                        },
                    );
                }
            })
            .catch((res) => {
                this.setState({
                    f1PackageReceivePageLoad: true,
                });
            });
    };

    fetchAndMergeMessages = (eoneNumber, products) => {
        let params = {
            messageKey: eoneNumber,
            messageMode: 'F1_ORDER',
        };
        this.props.getF1MessageList(params).then((msgRes) => {
            console.log(
                'getF1MessageList msgRes',
                msgRes,
                '===products===',
                products,
            );
            if (
                msgRes &&
                msgRes.status === 'success' &&
                Array.isArray(msgRes.data)
            ) {
                const msgMap = new Map(msgRes.data.map((m) => [m.sku, m]));

                // 合并：以 products 为主，把消息挂到对应 sku 上
                const merged = products.map((p) => ({
                    ...p,
                    message: msgMap.get(p.sku) || null, // 这里可以自定义字段
                }));

                this.setState({mergedProducts: merged});
            } else {
                // 第二条接口失败/无数据 -> 原样渲染
                this.setState({mergedProducts: products});
            }
        });
    };

    getRouterState = () => {
        let routerState = '';
        if (this.props.history.location.state) {
            routerState = this.props.history.location.state;
        }
        return routerState;
    };

    goBack = () => {
        this.props.setF1OrderOnGoPackageSource({$set: true});
        this.props.history.goBack();
    };

    showOrderNumber = (orderList) => {
        let routerState = this.getRouterState();
        if (JSON.stringify(routerState) !== '{}') {
            let number = 0;
            if (routerState.orderStatus === 'toBeReceived') {
                number = orderList.number;
            } else if (routerState.orderStatus === 'received') {
                number = orderList.number;
            } else if (routerState.orderStatus === 'toBeShipped') {
                number = orderList.number;
            }
            this.setState({
                orderNumber: number,
            });
        }
    };

    receiveSingleHandleCheck = (index, event) => {
        let isCheckedFlag = event.target.checked;
        let currentWaitReceiveList = JSON.parse(
            JSON.stringify(this.state.f1WaitReceivedList),
        );
        currentWaitReceiveList.products.map(
            (f1WaitReceivedItem, f1WaitReceivedIndex) => {
                if (index === f1WaitReceivedIndex) {
                    f1WaitReceivedItem.checked = isCheckedFlag;
                }
            },
        );

        this.setState({
            f1WaitReceivedList: currentWaitReceiveList,
        });
    };

    viewMessageComment = (sku, packageReceiveIndex, expandLessMessageFlag) => {
        let currentWaitReceiveList = JSON.parse(
            JSON.stringify(this.state.f1WaitReceivedList),
        );
        currentWaitReceiveList.products.map(
            (f1WaitReceivedItem, f1WaitReceivedIndex) => {
                if (packageReceiveIndex === f1WaitReceivedIndex) {
                    f1WaitReceivedItem.expandLessMessageFlag =
                        !expandLessMessageFlag;
                }
            },
        );

        this.setState({
            f1WaitReceivedList: currentWaitReceiveList,
        });
    };

    viewF1OrderMessageComment = () => {
        let {f1OrderExpandLessMessageFlag} = this.state;
        this.setState({
            f1OrderExpandLessMessageFlag: !f1OrderExpandLessMessageFlag,
        });
    };

    allReceiveHandleCheck = (name) => (event) => {
        let allf1WaitReceivedList = JSON.parse(
            JSON.stringify(this.state.f1WaitReceivedList),
        );
        JSON.stringify(allf1WaitReceivedList) !== '{}' &&
            allf1WaitReceivedList.products.map((item, idx) => {
                item.checked = event.target.checked;
            });

        this.setState({
            checkAll: event.target.checked,
            f1WaitReceivedList: allf1WaitReceivedList,
        });
    };

    allReceivePackage = () => {
        this.setState({
            cancelReceivePackageDialogOpened: true,
        });
    };

    confirmReceivePackageHandle = () => {
        let allReceivedList = JSON.parse(
            JSON.stringify(this.state.f1WaitReceivedList),
        );
        let allProducts = [];
        JSON.stringify(allReceivedList) !== '{}' &&
            allReceivedList.products.map((item, idx) => {
                let currentItem = Object.assign({}, item);
                if (currentItem.checked) {
                    allProducts.push(currentItem);
                }
            });

        allReceivedList.products = allProducts;
        this.props
            .f1ReceivePackage(allReceivedList)
            .then((res) => {
                if (res && res.status === 'success') {
                    this.props.openNotification(
                        T('notification_successful_receipt_of_goods'),
                        'success',
                    );
                    this.getPackageReceive();

                    let orderId = '';
                    let routerState = this.getRouterState();
                    if (typeof routerState.id !== 'undefined') {
                        orderId = parseInt(routerState.id);
                    }
                    this.props.updateF1OrderReceiveSearchList({
                        queryKey: {$set: ''},
                    });
                    // this.props.history.push(`/F1OrderReceiveManagement/${ orderId }`);
                    this.props.history.replace('/F1OrderList');
                    this.setState({
                        cancelReceivePackageDialogOpened: false,
                    });
                }
            })
            .catch((res) => {
                this.props.openNotification(
                    T('notification_goods_failed'),
                    'danger',
                );
                this.setState({
                    cancelReceivePackageDialogOpened: false,
                });
            });
    };

    dialogDidClose = (dialog) =>
        this.state[dialog] && this.setState({[dialog]: false});

    getReceivePackageQuantity = () => {
        let allReceivedList = JSON.parse(
            JSON.stringify(this.state.f1WaitReceivedList),
        );
        let checkedQuantity = 0;
        if (JSON.stringify(allReceivedList) !== '{}') {
            if (
                allReceivedList.products &&
                allReceivedList.products.length > 0
            ) {
                allReceivedList.products.map((receiveItem, receiveIndex) => {
                    if (receiveItem.checked) {
                        ++checkedQuantity;
                    }
                });
            }
        }
        return checkedQuantity;
    };

    getSteps = () => {
        return ['送达签收', '当地配送中', '提货已完成'];
    };

    getStepContent = (step) => {
        let stepsTimeArry = this.state.stepsTimeArry;
        let stepTime = '';
        stepsTimeArry.length > 0 &&
            stepsTimeArry.forEach((stepTimeObj, stepTimeIndex) => {
                if (step === stepTimeIndex) {
                    stepTime = stepTimeObj;
                }
            });
        return stepTime;
        // switch (step) {
        //   case 0:
        //     return `2021-07-12 07:59:00`;
        //   case 1:
        //     return '2021-07-10 07:56:00';
        //   case 2:
        //     return `2021-07-08 06:56:00`;
        //   default:
        //     return 'Unknown step';
        // }
    };

    render() {
        const {F1OrderDetails, queryKey, viewOrderTrackingData, f1MessageList} =
            this.props;
        const {
            checkAll,
            f1WaitReceivedList,
            f1WaitShippedList,
            packageStatus,
            f1PackageReceivePageLoad,
            cancelReceivePackageDialogOpened,
            activeStep,
            stepsTimeArry,
            stepsDescriptionArry,
            trackAndTraceLogsArry,
            currentCarrierName,
            f1OrderExpandLessMessageFlag,
        } = this.state;
        const steps = this.getSteps();
        const skuAllMessage =
            (f1MessageList &&
                f1MessageList.data &&
                f1MessageList.data['SKU_ALL']) ||
            [];

        console.log('viewOrderTrackingData', viewOrderTrackingData);
        console.log(
            'f1MessageList SKU_ALL',
            f1MessageList &&
                f1MessageList.data &&
                f1MessageList.data['SKU_ALL'],
        );
        let checkedQuantity = this.getReceivePackageQuantity();
        if (F1OrderDetails.orderProducts) {
            for (let n = 0; n < F1OrderDetails.orderProducts.length; n++) {
                F1OrderDetails.orderProducts[n]['checked'] = true;
            }
        }
        return (
            <div className="F1-order-receive-container">
                <div className="container-max-width is-fixed background"></div>
                <div className="container-max-width is-fixed background-cover"></div>

                <Header
                    hasUserCenter={true}
                    hasArrowBackIos={true}
                    backEvent={this.goBack}>
                    <p className="header-order-number">
                        {T('host_fone_order_number')}{' '}
                        <span className="numer"
                        testid="f1-receipt-detail-order-number">
                         {f1WaitReceivedList.number}
                        </span>
                    </p>
                    <div className="header-search-input">
                        <SearchInput
                            title="queryKey"
                            value={queryKey}
                            placeholder={T('enter_sku')}
                            search={this.search}
                            onChange={this.onChange}></SearchInput>
                    </div>
                </Header>

                <div className="f1-on-the-go-package-receive-order-header">
                    {skuAllMessage &&
                    skuAllMessage.length > 0 &&
                    f1OrderExpandLessMessageFlag ? (
                        <div className="message-list-container to-all-message-list">
                            <ul>
                                {skuAllMessage.map((message) => (
                                    <li
                                        key={message.id}
                                        className="message-item-container">
                                        <div className="message-sender">
                                            <div className="message-from">
                                                {message.fromUserName}
                                            </div>
                                            <div className="message-timestamp">
                                                {message.updateTime}
                                            </div>
                                        </div>
                                        <div className="message-content">
                                            {message.content}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ) : null}
                    <div className="f1-order-container">
                        <p className="header-order-number">
                            <label className="header-value">
                                {T('fone_order_dn_number')}
                            </label>
                            <span className="order-numer">
                                {f1WaitReceivedList.shipmentNumber}
                            </span>
                        </p>
                        <div className="f1-order">
                            <label className="header-value">
                                {T('fone_order_branch_name')}
                            </label>
                            <span className="f1-order-numer-value">
                                {f1WaitReceivedList.branchName}
                            </span>
                        </div>
                    </div>
                    <div className="f1-carrier-name-container">
                        <div className="header-order-number">
                            <label className="header-value">
                                {T('host_logistics_company')}
                            </label>
                            <span className="carrier-name-value">
                                {currentCarrierName}
                                {/* {trackAndTraceLogsArry && trackAndTraceLogsArry[0].carrierName} */}
                            </span>
                        </div>
                    </div>
                    <div className="f1-eone-status-and-branch-name">
                        <div className="f1-order">
                            <label className="header-value">
                                {T('host_fone_e1_order_number')}
                            </label>
                            <span className="f1-order-numer-value">
                                {f1WaitReceivedList.eoneNumber}
                            </span>
                        </div>
                        <span className="f1-status">
                            <label className="header-value">
                                {T('host_fone_order_status')}
                            </label>
                            <span className="order-status-value">
                                {T(f1WaitReceivedList.eoneStatus)}
                            </span>
                        </span>
                    </div>

                    <div className="f1-shipment-content">
                        <div className="f1-shipment-time">
                            <label className="header-value">
                                {T('host_fone_replenishment_date')}
                            </label>
                            <span className="f1-shipment-time-value">
                                {f1WaitReceivedList.createTime}
                            </span>
                        </div>
                    </div>

                    {/* {stepsDescriptionArry.length > 0 ? <div className="f1-order-stepper">
                            <Stepper activeStep={activeStep} orientation="vertical" className="stepper-container">
                                {stepsDescriptionArry.map((label, index) => (
                                    <Step key={label} className="step-content" disabled = {true}>
                                    <StepLabel className={index === 0 ? "step-label first-step-label" : "step-label"}>{label}</StepLabel>
                                    <Typography className="step-time">{this.getStepContent(index)}</Typography>
                                    </Step>
                                ))}
                            </Stepper>
                        </div> : null} */}

                    {trackAndTraceLogsArry.length > 0 ? (
                        <div class="contract-operate_recodeMain">
                            <ul class="contract-operate_recode_date">
                                {trackAndTraceLogsArry.map(
                                    (trackingItem, index) => (
                                        <li
                                            key={`${
                                                trackingItem.eventTime || index
                                            }-${index}`}>
                                            <i></i>
                                            <div className="spanList">
                                                <div className="tracking-left">
                                                    <div className="tracking-event-description">
                                                        {
                                                            trackingItem.eventDescription
                                                        }
                                                    </div>
                                                    {trackingItem.eventLocation ? (
                                                        <span className="tracking-location">
                                                            {
                                                                trackingItem.eventLocation
                                                            }
                                                        </span>
                                                    ) : null}
                                                </div>
                                                <div className="tracking-right">
                                                    <span className="tracking-time">
                                                        {trackingItem.eventTime}
                                                    </span>
                                                </div>
                                            </div>
                                        </li>
                                    ),
                                )}
                            </ul>
                        </div>
                    ) : null}
                </div>
                {f1PackageReceivePageLoad ? (
                    <LoadingIcon className="circle-animation" />
                ) : (
                    <div className="on-the-go-package-container">
                        <ul className="f1-shippment-wait-shipped">
                            {JSON.stringify(f1WaitShippedList) !== '{}' &&
                            f1WaitShippedList.waitShipSkus.length > 0
                                ? f1WaitShippedList.waitShipSkus.map(
                                      (waitShipItem, waitShipIndex) => (
                                          <li key={waitShipIndex}>
                                              <div className="first-row">
                                                  <div className="wait-shipped-sku">
                                                      {T('host_product_sku')}
                                                      <span className="sku-value">
                                                          {waitShipItem.sku}
                                                      </span>
                                                  </div>
                                                  <span className="f1-wait-shipped-quantity">
                                                      {T('host_wait_quantity')}
                                                      <span className="sku-quantity">
                                                          {
                                                              waitShipItem.quantity
                                                          }
                                                      </span>
                                                  </span>
                                              </div>
                                          </li>
                                      ),
                                  )
                                : null}
                        </ul>

                        <ReceivePackageCard
                            f1PackageReceive={f1WaitReceivedList}
                            packageStatus={packageStatus}
                            viewMessageComment={this.viewMessageComment}
                            f1MessageList={f1MessageList && f1MessageList.data}
                            receiveSingleHandleCheck={
                                this.receiveSingleHandleCheck
                            }></ReceivePackageCard>
                    </div>
                )}

                <div className="footer-wrap">
                    <div className="footer clearfix container-max-width is-fixed">
                        <div className="all-selected" xs={3}>
                            <Checkbox
                                checked={checkAll}
                                onChange={this.allReceiveHandleCheck(
                                    'checkAll',
                                )}
                            />
                            <span className="all-selected-title">
                                {T('f1_order_receive_select_all')}
                            </span>
                        </div>
                        <BasicButton
                            className="all-receive-btn pull-right"
                            type="primary"
                            disabled={checkedQuantity > 0 ? false : true}
                            onClickOfSingleTap={this.allReceivePackage}
                            testid="f1-receipt-receive-button">
                            {T('shippment_take_goods')}
                        </BasicButton>
                    </div>
                </div>

                <Dialog
                    opened={cancelReceivePackageDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('cancelReceivePackageDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="receive-package-dialog">
                        <h5 className="receive-package-dialog-title text-center">
                            {T('order_confirm_receive')}
                        </h5>
                        <p className="receive-package-dialog-desc text-center">
                            {T('host_confirm_receive')}
                        </p>
                        <div className="receive-package-btn-container">
                            <BasicButton
                                type="primary"
                                className="receive-confirm-btn"
                                onClickOfSingleTap={
                                    this.confirmReceivePackageHandle
                                }
                                testid="f1-receipt-confirm-button">
                                {T('order_confirm')}
                            </BasicButton>
                            <BasicButton
                                type="primary"
                                className="cancel-confirm-btn"
                                onClickOfSingleTap={() =>
                                    this.dialogDidClose(
                                        'cancelReceivePackageDialogOpened',
                                    )
                                }>
                                {T('cancel')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {host} = state;
    return {
        F1OrderDetails: host.F1OrderDetails,
        skuReplenishmentDetail: host.skuReplenishmentDetail,
        queryKey: host.f1OrderReceiveSearchfields.queryKey,
        updateF1OrderList: host.updateF1OrderList,
        f1ShipmentWaitReceive: host.f1ShipmentWaitReceive,
        f1ShipmentWaitshipped: host.f1ShipmentWaitshipped,
        f1ShipmentReceived: host.f1ShipmentReceived,
        viewOnTheGoPackageList: host.viewOnTheGoPackageList,
        viewOrderTrackingData: host.viewOrderTrackingData,
        orderDetailMessageList: host.orderDetailMessageList,
        f1MessageList: host.f1MessageList,
    };
};

const mapDispatchToProps = {
    openNotification,
    updateF1OrderReceiveSearchList,
    getF1ShipmentWaitReceive,
    viewOnTheGoPackage,
    getF1ShipmentWaitShipped,
    getF1ShipmentReceived,
    f1ReceivePackage,
    viewOrderTracking,
    setF1OrderOnGoPackageSource,
    getF1MessageList,
    clearF1PackageData,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(F1OrderOnTheGoPackageReceive);
